import React from 'react'
import styled from 'styled-components'

import Table from 'LuxKit/Tables/Table'
import TableBody from 'LuxKit/Tables/TableBody'
import TableBodyCell from 'LuxKit/Tables/TableBodyCell'
import TableBodyRow from 'LuxKit/Tables/TableBodyRow'
import TableHeader from 'LuxKit/Tables/TableHeader'
import TableHeaderCell from 'LuxKit/Tables/TableHeaderCell'
import TableHeaderRow from 'LuxKit/Tables/TableHeaderRow'

import Group from 'components/utils/Group'
import FormatCurrency from 'components/Common/FormatCurrency'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import BodyText from 'LuxKit/Typography/BodyText'
import config from 'constants/config'

const TableBodyRowTotal = styled(TableBodyRow)`
  background-color: ${props => props.theme.palette.neutral.default.seven};
`

interface Props {
  oldPrice: number
  newPrice: number
  oldPropertyFees: number
  newPropertyFees: number
  className?: string
}

function PriceChangeViewV2(props: Props) {
  const {
    oldPrice,
    newPrice,
    oldPropertyFees,
    newPropertyFees,
    className,
  } = props

  return (
    <Group direction="vertical" gap={16} className={className}>
      <Table>
        <TableHeader>
          <TableHeaderRow>
            <TableHeaderCell minWidth={96}></TableHeaderCell>
            <TableHeaderCell minWidth={96}>
              <BodyText variant="medium" colour="neutral-three">Before</BodyText>
            </TableHeaderCell>
            <TableHeaderCell minWidth={96}>
              <BodyText variant="medium">Now</BodyText>
            </TableHeaderCell>
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          {oldPropertyFees !== newPropertyFees && (
            <>
              <TableBodyRow>
                <TableBodyCell>
                  <BodyText variant="medium">Pay Now</BodyText>
                </TableBodyCell>
                <TableBodyCell>
                  <BodyText variant="medium" colour="neutral-three" strikeThrough={newPrice !== oldPrice}>
                    <FormatCurrency value={oldPrice} />
                  </BodyText>
                </TableBodyCell>
                <TableBodyCell>
                  <BodyText variant="medium">
                    <FormatCurrency value={newPrice} />
                  </BodyText>
                </TableBodyCell>
              </TableBodyRow>
              <TableBodyRow>
                <TableBodyCell>
                  <BodyText variant="medium">Pay at hotel</BodyText>
                  <BodyText variant="small">Local Tax</BodyText>
                </TableBodyCell>
                <TableBodyCell>
                  <BodyText variant="medium" colour="neutral-three" strikeThrough>
                    <FormatCurrency value={oldPropertyFees} />
                  </BodyText>
                </TableBodyCell>
                <TableBodyCell>
                  <BodyText variant="medium">
                    <FormatCurrency value={newPropertyFees} />
                  </BodyText>
                </TableBodyCell>
              </TableBodyRow>
            </>
          )}
          <TableBodyRowTotal>
            <TableBodyCell>
              <BodyText variant="medium" weight="bold">Total</BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="medium" weight="bold" colour="neutral-three" strikeThrough>
                <FormatCurrency value={oldPrice + oldPropertyFees} />
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="medium" weight="bold">
                <FormatCurrency value={newPrice + newPropertyFees} />
              </BodyText>
            </TableBodyCell>
          </TableBodyRowTotal>
        </TableBody>
      </Table>
      {oldPropertyFees !== newPropertyFees && <BodyTextBlock variant="medium">
        Property fees are estimated by {config.title} based on information provided by the property and are subject to change.
      </BodyTextBlock>}
    </Group>
  )
}

export default PriceChangeViewV2
